import React from 'react'
import Swipe from 'react-easy-swipe'
import { withRouter } from 'react-router'
import RateOutFitCard from '../templates/RateOutFitCard'
import StarRatingHOC from './StarRatingHOC'
import TagsOverlayHOC from './TagsOverlayHOC'
import ArrowNavHOC from './ArrowNavHOC'


class RateOutFitCardHOC extends React.Component {


constructor(props) {
    super(props);
    //console.log('props', props)
    this.handleRatingUpdate = this.handleRatingUpdate.bind(this)
    this.state = {
      rating: 0,
      visiblerating: 0,
      swipeStyle: { transform: 'rotateZ(0deg) translate3d(0, 0, 0)'},
      swipeClass: '',
      ratingError: false,
      selectedTags: []
    }
  }

/*
  static propTypes = {
    match: PropTypes.object.isRequired
  }
*/
  onSwipeStart = (event) => {
    //console.log('target', event.target)
    if(this.props.tagsVisible) return

    //console.log('onSwipeStart', event)
    //this.setState({swipeStyle: { transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}})
    //this.setState({buttonLeaveClass: { position: 'absolute', transform: 'scaleX(100) translate3d(0, 0, 0)', opacity: 1 }})

  }

  onSwipeMove = (position, event) => {
    if(this.props.tagsVisible) return
    //console.log('onSwipeMove')
  
    this.setState({ x: position.x })

    if(position.x < -20){
      this.setState({swipeClass: 'swiping'})
      let x = -position.x
      if(this.state.rating === 0){
        //console.log('testing', x)
        if(x >= 100){
          x = 100
        }
      }
      this.setState({swipeStyle: { transform: 'rotateZ(-'+(x/620)*20+'deg) translate3d(-'+(x/620)*200+'%, 0, 0)'}})
    }

  }

  onSwipeEnd = (event) => {
    //if(event.target === starRating) return
    if(this.state.rating === 0){
      
      if(this.state.x < -40){
        setTimeout(()=>{ 
        this.setState({ratingError: true})
        this.setState({visiblerating: 5})
        this.setState({})
        }, 400);
        setTimeout(()=>{ 
        this.setState({ratingError: false})
        this.setState({visiblerating: 0})
        }, 800);
      }

      this.setState({swipeClass: ''})
      this.setState({swipeStyle: { transition: 'transform 400ms', transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}})
      this.setState({ x: 0 })
      return
    }else{

        if(this.state.x < -160){
        //this.setState({swipeClass: 'swiped'})
        const tags = this.state.selectedTags.map( (tag) =>{
          return tag.label
        })
        const rating = this.state.rating
        const outfit = this.props.outfit.id
        //console.log('rating', rating)
        this.props.onItemRemove(rating, outfit, tags)

        this.setState({swipeStyle: { transition: 'transform 400ms', transform: 'rotateZ(-20deg) translate3d(-200%, 0, 0)'}})
        this.setState({ x: 0 })
        //this.setState({buttonLeaveClass: { position: 'absolute', transform: 'scaleX(100) translate3d(0, 0, 0)', opacity: 1 }})
      }else{
        this.setState({swipeClass: ''})
        this.setState({swipeStyle: { transition: 'transform 400ms', transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}})
        this.setState({ x: 0 })
        //this.setState({buttonLeaveClass: { position: 'absolute', transform: 'scaleX(100) translate3d(0, 0, 0)', opacity: 1 }})
      }

    } 

  }

  onArrowClick = () => {
    if(this.props.tagsVisible) return
    //console.log('testing')
    if(this.state.rating === 0) {

      this.setState({swipeClass: 'swiping'})
      const x = 100
      this.setState({swipeStyle: { transition: 'transform 200ms', transform: 'rotateZ(-'+(x/620)*20+'deg) translate3d(-'+(x/620)*200+'%, 0, 0)'}})
      setTimeout(()=>{ 
      this.setState({swipeStyle: { transition: 'transform 400ms', transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}})
      }, 200);
      setTimeout(()=>{ 
      this.setState({ratingError: true})
      this.setState({visiblerating: 5})
      }, 550);
      setTimeout(()=>{ 
      this.setState({swipeClass: ''})
      this.setState({ratingError: false})
      this.setState({visiblerating: 0})
      }, 950);
      return
    }else{
      this.setState({swipeClass: 'swiping'})
            //this.setState({swipeClass: 'swiped'})
      const tags = this.state.selectedTags.map( (tag) =>{
        return tag.label
      })
      const rating = this.state.rating
      const outfit = this.props.outfit.id
      this.setState({swipeStyle: { transition: 'transform 400ms, opacity 100ms 200ms', opacity: '0', transform: 'rotateZ(-10deg) translate3d(-100%, 0, 0)'}})
      setTimeout(()=>{ 
      this.setState({swipeStyle: { display: 'none'}})
      }, 300);
      this.props.onItemRemove(rating, outfit, tags)
    }


  }

  handleRatingUpdate = (rating) => {
    //console.log('props', this.props)
    this.setState({rating: rating})
    this.setState({visiblerating: rating})
  }

  setSelectedTags = (selectedTags) => {
    this.setState({selectedTags: selectedTags})
    //console.log('selectedTags', selectedTags)
    this.props.setSelectedTags(selectedTags)
  }

  render () {

    if(this.props.visible ){
      if(this.props.active){
        return (
          <div>
          <Swipe className={`currentCard ${this.state.swipeClass} ${this.props.lastCardClass}`} style={this.state.swipeStyle} allowMouseEvents={false} onSwipeMove={this.onSwipeMove} onSwipeStart={this.onSwipeStart} onSwipeEnd={this.onSwipeEnd} >
            <RateOutFitCard swipeClass={this.state.swipeClass} location={this.props.outfit.location} imageurl={this.props.outfit.imageurl}>
              <div className="outfitCount">{this.props.cardIndex}/5</div>
              <StarRatingHOC ratingError={this.state.ratingError} rate={ this.state.visiblerating } onRatingUpdate={ this.handleRatingUpdate } />
              <TagsOverlayHOC toggleTagsOverLay={this.props.toggleTagsOverLay} setSelectedTags={this.setSelectedTags} selectedTags={ this.state.selectedTags } visible={ this.props.tagsVisible } />
            </RateOutFitCard>
            <div className={`cardShadow ${this.state.swipeClass}`} ></div>
          </Swipe>
            <ArrowNavHOC onClickHandler={this.onArrowClick} />
          </div>
        )
      }else{
        return (
          <RateOutFitCard swipeClass={this.state.swipeClass} noShadow={this.props.noShadow} swipeStyle={this.state.swipeStyle} location={this.props.outfit.location} imageurl={this.props.outfit.imageurl}>
              <div className="outfitCount">{this.props.cardIndex}/5</div>
              <StarRatingHOC />
          </RateOutFitCard>
        )
      }
      
    }else{
    return null
    }
  }

}



export default RateOutFitCardHOC = withRouter(RateOutFitCardHOC)



// WEBPACK FOOTER //
// ./src/components/RateOutFitCardHOC.js